import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { FiltersService } from '../../../../services/filters.service';
import { FormBuilder, FormArray, FormGroup } from '@angular/forms';
import { PropertiesService } from 'src/app/services/properties.service';

@Component({
  selector: 'app-update-propertie',
  templateUrl: './update-propertie.component.html',
  styleUrls: ['./update-propertie.component.css'],
  standalone: false
})
export class UpdatePropertieComponent implements OnInit {

  propiedad: any = {};
  localidades: any[] = [];
  tipoPropiedades: any[] = [];
  tipoOperaciones: any[] = [];
  caracteristicasPropiedad: any[] = [];
  tipoMonedas: any[] = [];

  mensajeErrorIA: string = "";
  loading: boolean = false;
  error: boolean = false;
  msjError: string = "";

  productFormGroupCarct: FormArray = this.formBuilder.array([]); // 👈 inicializado vacío
  aptoCreditoId: number | null = null;

  private _catalogoReady = { caract: false };
  private _propReady = false;

  caractPropList: any[] = [];

  constructor(
    private activateRoute: ActivatedRoute,
    private router: Router,
    private filtersServ: FiltersService,
    public formBuilder: FormBuilder,
    private propertiesService: PropertiesService
  ) { }

  ngOnInit() {
    this.getLocalidades();
    this.getTipoPro();
    this.getTipoOpe();
    this.getTipoMoneda();
    this.getCaractProp();
    this.getPropiedad();
  }

  // ==== Getter para usar en la vista ====
  get caracteristicas(): FormArray {
    return this.productFormGroupCarct as FormArray;
  }

  // ==== Helpers ====
  public isTruthy(v: any): boolean {
    if (typeof v === 'boolean') return v;
    if (v === 1 || v === '1') return true;
    if (v === 0 || v === '0') return false;
    if (typeof v === 'string') {
      const s = v.trim().toLowerCase();
      return s === 'true' || s === 'si' || s === 'sí';
    }
    return !!v;
  }

  private tryBuildCaracteristicasForm() {
    if (!this._catalogoReady.caract || !this._propReady) return;

    this.productFormGroupCarct = this.formBuilder.array([]);
    this.caractPropList.forEach(caracteristica => {
      const isApto = this.aptoCreditoId != null && (caracteristica.id === this.aptoCreditoId);
      const valor = isApto ? this.isTruthy(caracteristica.cantidad) : caracteristica.cantidad;

      this.productFormGroupCarct.push(
        this.formBuilder.group({
          caractPropId: [caracteristica.id],
          caractPropValor: [valor]
        })
      );
    });
  }

  // ==== Carga de datos ====
  getPropiedad() {
    this.activateRoute.params.subscribe(params => {
      this.propertiesService.getpropiedad(params.id).subscribe({
        next: (data: any) => {
          this.propiedad = {
            id: data.id,
            descripcionCorta: data.descripcionCorta,
            descripcionLarga: data.descripcionLarga,
            infoInterna: data.infoInterna,
            tipoOperacionId: data.tipoOperacion.id,
            tipoMonedaId: data.tipoMoneda.id,
            tipoPropiedadId: data.tipoPropiedad.id,
            videoUrl: data.videoUrl,
            precio: data.precio,
            calle: data.domicilio.calle,
            numero: data.domicilio.numero,
            piso: data.domicilio.piso,
            depto: data.domicilio.departamento,
            callesEntre: data.domicilio.callesEntre,
            domicilioId: data.domicilio.id,
            barrioId: data.domicilio.barrio?.id,
            localidadId: data.domicilio.barrio?.localidad?.id,
            provinciaId: data.domicilio.barrio?.localidad?.provincia?.id,
            paisId: data.domicilio.barrio?.localidad?.provincia?.pais?.id,
            lat: data.domicilio.lat,
            lng: data.domicilio.lng
          };

          this.caractPropList = data.caracteristicasPropiedad || [];

          this._propReady = true;
          this.tryBuildCaracteristicasForm();
        },
        error: (err) => console.log(err)
      });
    });
  }

  //#region Catálogos
  getLocalidades() {
    this.filtersServ.getLocalidad().subscribe({
      next: (data: any[]) => {
        this.localidades = data;
        this.localidades.unshift({ descripcion: 'Ciudad', id: '' });
      },
      error: (err) => console.log(err)
    });
  }

  getTipoPro() {
    this.filtersServ.getTipoPro().subscribe({
      next: (data: any[]) => {
        this.tipoPropiedades = data;
        this.tipoPropiedades.unshift({ descripcion: 'Tipo propiedad', id: '' });
      },
      error: (err) => console.log(err)
    });
  }

  getTipoOpe() {
    this.filtersServ.getTipoOpe().subscribe({
      next: (data: any[]) => {
        this.tipoOperaciones = data;
        this.tipoOperaciones.unshift({ descripcion: 'Tipo Operación', id: '' });
      },
      error: (err) => console.log(err)
    });
  }

  getCaractProp() {
    this.filtersServ.getCaracteristicasProp().subscribe({
      next: (data: any[]) => {
        const apto = data.find(c => (c.descripcion || '').toLowerCase().includes('apto'));
        this.aptoCreditoId = apto?.id ?? null;

        this.caracteristicasPropiedad = data;
        this.caracteristicasPropiedad.unshift({ descripcion: 'Caracteristica', id: '' });

        this._catalogoReady.caract = true;
        this.tryBuildCaracteristicasForm();
      },
      error: (err) => console.log(err)
    });
  }

  getTipoMoneda() {
    this.filtersServ.getTipoMoneda().subscribe({
      next: (data: any[]) => {
        this.tipoMonedas = data;
        this.tipoMonedas.unshift({ descripcion: 'Moneda', id: '' });
      },
      error: (err) => console.log(err)
    });
  }
  //#endregion

  // ==== Acciones ====
  ActualizarPropiedad(form: NgForm) {
    const caractList: any[] = [];
    if (this.productFormGroupCarct?.value?.length) {
      this.productFormGroupCarct.value.forEach(item => {
        caractList.push({
          caracteristicasPropiedadId: item.caractPropId,
          valor: item.caractPropValor
        });
      });
    }

    const propiedadUpd = {
      id: this.propiedad.id,
      descripcionCorta: form.controls.descripcionCorta?.value,
      descripcionLarga: form.controls.descripcionLarga?.value,
      infoInterna: form.controls.infoInterna?.value,
      valorPropiedad: form.controls.precio?.value,
      tipoMoneda: form.controls.tipoMoneda?.value,
      caracteristicasPropiedadPropiedadValor: caractList,
      domicilio: [{
        id: this.propiedad.domicilioId,
        calle: form.controls.calle?.value,
        numero: form.controls.numero?.value,
        piso: form.controls.piso?.value,
        departamento: form.controls.depto?.value,
        callesEntre: form.controls.callesEntre?.value,
        barrioId: this.propiedad.barrioId,
        propiedadId: this.propiedad.id,
        lat: this.propiedad.lat,
        lng: this.propiedad.lng,
      }],
      videoUrl: form.controls.videoUrl?.value,
      propiedadTipoOperacionId: form.controls.tipoOp?.value,
      propiedadTipoPropiedadId: form.controls.tipoPro?.value
    };

    this.propertiesService.putPropiedad(propiedadUpd.id, propiedadUpd).subscribe({
      next: () => this.router.navigate(['/admin/principal']),
      error: (err) => console.log(err)
    });
  }

  back() {
    this.router.navigate(['/admin/principal']);
  }

  // ==== Dinámico Características ====
  deleteCaractetistica(i: number) {
    this.productFormGroupCarct.removeAt(i);
  }

  addCaractetistica() {
    this.productFormGroupCarct.push(
      this.formBuilder.group({
        caractPropId: '',
        caractPropValor: ''
      })
    );
  }

  // ==== Map ====
  updateLatLng(coords: { lat: number; lng: number }) {
    this.propiedad.lat = coords.lat;
    this.propiedad.lng = coords.lng;
  }

  // ==== IA ====
  confirmarIA(f: any) {
    const ok = confirm('⚠️ Generar la descripción con IA tiene un costo. ¿Está seguro?');
    if (ok) this.GenerarDescripcionIA(f);
  }

  GenerarDescripcionIA(form: NgForm) {
    this.loading = true;
    this.error = false;
    this.msjError = '';

    const caractListText: string[] = [];

    if (this.productFormGroupCarct?.value?.length) {
      this.productFormGroupCarct.value.forEach(item => {
        const cat = this.caracteristicasPropiedad.find(c => c.id === item.caractPropId);
        if (cat) {
          caractListText.push(`${cat.descripcion}: ${item.caractPropValor}`);
        }
      });
    }

    const tipoOperacion = this.tipoOperaciones.find(o => o.id === form.controls.tipoOp.value);
    const tipoPropiedad = this.tipoPropiedades.find(p => p.id === form.controls.tipoPro.value);
    const localidad = this.localidades.find(l => l.id === form.controls.localidad.value);

    if (tipoOperacion) caractListText.push(`Operación: ${tipoOperacion.descripcion}`);
    if (tipoPropiedad) caractListText.push(`Tipo de propiedad: ${tipoPropiedad.descripcion}`);
    if (form.controls.piso?.value) caractListText.push(`Piso: ${form.controls.piso.value}`);
    if (localidad) caractListText.push(`Ubicación: ${localidad.descripcion}`);

    const payload = {
      infoInterna: form.controls.infoInterna.value,
      caracteristicas: caractListText
    };

    this.propertiesService.generarDescripcion(payload).subscribe({
      next: (res: any) => {
        this.propiedad.descripcionCorta = res.descripcionCorta;
        this.propiedad.descripcionLarga = res.descripcionLarga;
        this.loading = false;
        this.error = false;
        this.msjError = '';
      },
      error: (err) => {
        this.loading = false;
        this.error = true;
        this.msjError = err?.error?.code === 'insufficient_quota'
          ? '⚠️ No tienes crédito disponible para usar IA.'
          : '❌ Ocurrió un error al generar la descripción con IA.';
        setTimeout(() => { this.msjError = ''; }, 5000);
      }
    });
  }
}
